import styled from '@emotion/styled';
import { Box } from '@mui/material';

export const ButtonAndIconWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;

  @media (max-width: 375px) {
    gap: 6px;
  }
`;

export const ButtonWithLabelWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .cta-button {
    &.secondary {
      padding: 8px;
      border: 1px solid;
      border-radius: 2px;
      min-width: 326px;
      min-height: 48px;
      font-size: 16px;
      font-weight: 700;
      &.hightlighted {
        border-radius: 0 2px 2px 2px;
      }
      &:hover {
        background-color: ${({ theme }) => theme.palette.colors.petrol[400]};
        &.hightlighted {
          border-color: ${({ theme }) => theme.palette.colors.petrol[400]};
        }
      }
    }
  }
`;

export const ButtonLabel = styled('span')`
  padding: 4px 8px 4px 8px;
  border-radius: 4px 4px 0 0;
  font-size: 14px;
  line-height: 1;
  font-weight: 700;
  background-color: ${({ theme }) => theme.palette.colors.petrol[400]};
  color: ${({ theme }) => theme.palette.colors.white};
`;
